import Vue from "vue";
import Router from "vue-router";
import Upload from "@/components/assetUploader";
import Account from "@/components/account";
import Login from "@/components/login";
import Loading from "@/components/lib/loading";
import store from "./store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

export default new Router({
  mode: "history",
  routes: [{
      path: "/",
      redirect: "/upload"
    },
    {
      path: "/upload",
      name: "Upload",
      component: Upload,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/notes",
      name: "Notes",
      component: Loading,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: ifNotAuthenticated
    }
  ]
});